import * as React from 'react';
import EDPieChart from '../../../../../BaseComponents/Charts/PieChart/EDPieChart';
import { PointOptionsObject, SeriesClickEventObject } from 'highcharts';
import GraphPanel from '../GraphPanel/GraphPanel';

interface IProps {
  title: string;
  link?: string;
  category?: string;
  codePrivilege?: string;
  sign?: string;
  data?: PointOptionsObject[];
  drilldownEvent?: (event: SeriesClickEventObject) => void;
}

class PieChartPanel extends React.PureComponent<IProps> {
  render() {
    return (
      <GraphPanel
        type="pie"
        title={this.props.title}
        subtitle={this.props.codePrivilege}
        link={this.props.link}
      >
        <EDPieChart
          title={this.props.title}
          category={this.props.category}
          data={this.props.data}
          drilldownEvent={this.props.drilldownEvent}
        />
      </GraphPanel>
    );
  }
}

export default PieChartPanel;
